import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type ScrollOnOverflowFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
};

const ScrollOnOverflowField = (props: ScrollOnOverflowFieldProps) => {
  return (
    <Autocomplete
      id="scrollOnOverflow"
      size="small"
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      value={props.value}
      options={[true, false]}
      autoHighlight
      getOptionLabel={(option: boolean) => (option ? "True" : "False")}
      fullWidth
      disableClearable
      renderInput={(params) => (
        <EditorVisualTextField
          {...params}
          name={props.name}
          fullWidth
          label="Scroll on Overflow"
        />
      )}
    />
  );
};

export default ScrollOnOverflowField;
